/**
 * Formateo de importes para el form offline.
 *
 * Se separa del componente para poder testear la logica sin instanciar todo
 * el `FormOfflineComponent` (que depende de dialog, servicios HTTP y spinner).
 *
 * Convencion del form: separador de miles con COMA y separador decimal con
 * PUNTO (ej: 12 -> "12.00", 1234.5 -> "1,234.50"), igual que el campo
 * "Tarifa por noche" (`price_night`).
 */

/**
 * Formatea un importe con 2 decimales fijos.
 *
 * - `null` / `undefined` / vacio / no numerico -> string vacio (el input
 *   muestra su placeholder: "Sin valor de referencia").
 * - Redondea a 2 decimales (mismo criterio que `price_night`).
 */
export function formatAmountEnUs(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  const num = typeof value === 'number' ? value : Number(String(value).replace(/,/g, ''));
  if (!Number.isFinite(num)) {
    return '';
  }
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num);
}

/**
 * Convierte un importe (ya formateado o crudo) a numero.
 *
 * Necesario porque el control `estimatedRate` guarda el valor FORMATEADO
 * (ej: "1,234.50") para que el input muestre el formato pedido, y el
 * payload tiene que seguir mandando el numero (ej: 1234.5).
 *
 * - `null` / `undefined` / vacio / no numerico -> null.
 */
export function parseAmountEnUs(value: number | string | null | undefined): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const num = typeof value === 'number' ? value : Number(String(value).replace(/,/g, ''));
  return Number.isFinite(num) ? num : null;
}
